module.exports = __webpack_public_path__ + "img/ps.4b3a66bd.svg";